import { CloudinaryAsset } from '../../types/schemas/objects/CloudinaryAsset';

export const getImageTransformations = (asset: CloudinaryAsset) => {
	return asset.derived?.[0].raw_transformation ?? '';
};
